import { useSelector } from 'react-redux';

import { makeSelectTranslationCommon } from '../../internationalization/intSelectors';
import { IModalRenderProps } from '../types/modalTypes';
import ModalSuccess from './ModalSuccess';

const ModalVersionUpdate = ({ onCloseModal }: Pick<IModalRenderProps, 'onCloseModal'>) => {
    const { modal, modalVersionUpdate } = useSelector(makeSelectTranslationCommon());

    return (
        <ModalSuccess
            btn={modalVersionUpdate.btn}
            title={modalVersionUpdate.title}
            translation={modal}
            onCloseModal={onCloseModal}
        >
            {modalVersionUpdate.text}
        </ModalSuccess>
    );
};

export default ModalVersionUpdate;
